import axios from 'axios';
import type { AxiosResponse } from 'axios';
import * as utils from '@/apis/apiUtils';
import type { SettouWorkType } from '@/lib/johaisetsu/johaisetsuCommonUtil';
import type {
  SettouPatrolReport,
} from '@/models/apis/johaisetsu/settouPatrol/settouPatrol/johaisetsuSettouPatrolReportsResponse';
import type {
  SettouOnsiteManagementReport,
} from '@/models/apis/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsuSettouOnsiteManagementReportsResponse';

export interface SettouReportIndexParams {
  ts_from: Date;
  ts_to: Date;
  work_types: SettouWorkType[];
  johaisetsu_area?: string;
  johaisetsu_han_names?: string[];
  road_name_disp?: string[];
  direction?: string;
  road_condition?: string;
}

export interface SettouReportIndexResponse {
  patrol_reports: SettouPatrolReport[];
  onsite_management_reports: SettouOnsiteManagementReport[];
}

export default {
  index(params: SettouReportIndexParams): Promise<AxiosResponse<SettouReportIndexResponse>> {
    return axios.get(utils.getApiUrl('/johaisetsu_settou_reports'), { params });
  },
  downloadCSV(params: SettouReportIndexParams): Promise<AxiosResponse<Blob>> {
    return axios.get(utils.getApiUrl('/johaisetsu_settou_reports/csv'), {
      params,
      responseType: 'blob',
    });
  },
};
